import ImageResolution from "./ImageResolution";

export class ImageCanvasWrapper
{
    image:HTMLImageElement
    imageResolution:ImageResolution;
    constructor(image:HTMLImageElement,imageResolution:ImageResolution)
    {   
        this.image= image;
        this.imageResolution = imageResolution;
    }
    getCanvas():HTMLCanvasElement
    {
        let canvas = document.createElement("canvas");
        canvas.width= this.imageResolution.width;
        canvas.height = this.imageResolution.height;
        let context = canvas.getContext("2d");
        context?.drawImage(this.image,0,0,this.imageResolution.width,this.imageResolution.height);
        return canvas;
    }

    getContext(): CanvasRenderingContext2D | null {
        let canvas = document.createElement("canvas");
        canvas.width = this.imageResolution.width;
        canvas.height = this.imageResolution.height;
        let context = canvas.getContext("2d");
        context?.drawImage(this.image, 0, 0, this.imageResolution.width, this.imageResolution.height);
        return context;
    }
}